<div class="grid-row padding-top-205">
    <sam-frontend-request-side-nav [fields1]="fields1" (filterEvent)="onFilterChange($event)"
        class="desktop:grid-col-3 tablet-lg:grid-col-12 mobile-lg:grid-col-12 margin-bottom-3">
    </sam-frontend-request-side-nav>

    <sds-page class="sds-page condensed desktop:grid-col-9">

    <!-- no records -->
    <ng-template #temp>
        <div>
            <hr>
        </div>
    </ng-template>

        <!-- MOBILE HEADER BLOCK -->
        <div *ngIf="isMobileResolution" class="header-block">
            <div class="grid-row grid-gap display-flex flex-row">
                <div class="grid-col-6 align-bottom">
                    <!-- top pagniation -->
                    <sds-pagination class="result-container padding-right-2" displayMode='results' [(page)]="page"
                        (pageChange)="onPageNumChange($event)" [totalItems]="totalRecords">
                    </sds-pagination>
                    <div class="no-results-display text-semibold" *ngIf="!requestData || requestData.length == 0" aria-live="polite">
                        Showing &nbsp;0&nbsp;-&nbsp;0&nbsp; of&nbsp; 0&nbsp; results
                    </div>
                </div>

                <!-- Sort by -->
                <div class="grid-col-6 float-right">
                    <div class="sds-field">
                        <form class="usa-form">
                            <label class="usa-label font-sans-2xs text-italic text-base" for="requestSort">Sort
                                By</label>
                            <select class="usa-select" name="options" id="requestSort" [(ngModel)]="selectedSort"
                                (ngModelChange)="loadRequestData()">
                                <option *ngFor="let option of SortConfiguration" [ngValue]="option">{{option.label}}
                                </option>
                            </select>
                        </form>
                    </div>
                </div>
            </div>
        </div>

        <!-- Desktop HEADER BLOCK -->
        <div *ngIf="!isMobileResolution" class="header-block">
            <div class="grid-row display-flex flex-row margin-top-neg-6">
                <div class="tablet:grid-col-4 grid-col-12">
                    <!-- top pagniation -->
                    <sds-pagination class="result-container padding-right-2" displayMode='results' [(page)]="page"
                        (pageChange)="onPageNumChange($event)" [totalItems]="totalRecords">
                    </sds-pagination>
                    <div class="no-results-display text-semibold" *ngIf="!requestData || requestData.length == 0" aria-live="polite">
                        Showing &nbsp;0&nbsp;-&nbsp;0&nbsp; of&nbsp; 0&nbsp; results
                    </div>
                </div>

                <!-- Sort by -->
                <div class="tablet:grid-col-8 grid-col-12">
                    <div class="sds-field float-right padding-left-2">
                        <form class="usa-form">
                            <label class="usa-label font-sans-2xs text-italic text-base" for="requestSort">Sort
                                By</label>
                            <select class="usa-select" name="options" id="requestSort" [(ngModel)]="selectedSort"
                                (ngModelChange)="loadRequestData()">
                                <option *ngFor="let option of SortConfiguration" [ngValue]="option">{{option.label}}
                                </option>
                            </select>
                        </form>
                    </div>
                </div>
            </div>
        </div>

    <!-- Request Listing -->
    <sds-search-result-list [model]="requestData" [customResultsTemplate]="temp">
        <ng-template #resultContent let-item>

          <div class="requests" target="_blank" (click)="redirectToView(item?.link)" style="cursor: pointer;">
            <!-- first row -->
            <div class="grid-row margin-top-1">
              <div class="grid-col-8">
                <p class="margin-bottom-3" [innerHTML]="item?.feeds"></p>
              </div>
              <div class="grid-col-4">
                <span class="display-flex"> <em class=" sds-status sds-status--sm "
                    [ngClass]="{'Pending':'sds-status--blue', 'Approved':'sds-status--green', 'Cancelled':'sds-status--gray', 'Rejected':'sds-status--red'}[item?.status]"></em>{{item?.status}}</span>
              </div>
            </div>

            <!-- second row -->
            <div class="grid-row margin-bottom-1">
              <div class="tablet:grid-col-8 grid-col-6">
                <small><em>{{item?.createdDate| date:"MMM d, y h:mm a"}}</em></small>
              </div>
              <div class="tablet:grid-col-4 grid-col-6" *ngIf="item?.status == 'Approved'">
                <small>
                  <p>{{item?.responderId}}</p>
                </small>
                <small>
                  <p>{{item?.responderDate| date:"MMM d, y h:mm a"}}</p>
                </small>
              </div>
            </div>
          </div>

        </ng-template>
      </sds-search-result-list>


      <sds-pagination *ngIf="requestData?.length" [paginationConfiguration]="bottom" [(page)]="page" (pageChange)="onPageNumChange($event)">
    </sds-pagination>
    </sds-page>
</div>